import { SVCurrencyInput } from '@/components/core';
import { PROGRAM_SETTINGS } from '@/constants/programSettings';
import { Grid, Stack, Typography } from '@mui/material';

export const CheckDepositControls = () => {
  const {
    MAX_DEPOSIT_PER_CHECK,
    MAX_DAILY_DEPOSIT_PER_BANK_ACCOUNT,
    MAX_MONTHLY_DEPOSIT_PER_BANK_ACCOUNT,
    MAX_DAILY_DEPOSIT_PER_PROGRAM,
  } = PROGRAM_SETTINGS.CHECK_DEPOSIT_CONTROLS;

  return (
    <Grid container spacing={3} alignItems="stretch">
      <Grid size={{ xs: 12, md: 6, lg: 6 }}>
        <Stack spacing={1} sx={{ width: '100%' }}>
          <SVCurrencyInput
            name="checkDepositLimitPerTransaction"
            label={MAX_DEPOSIT_PER_CHECK.LABEL}
          />
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 6 }}>
        <Stack spacing={1} sx={{ width: '100%' }}>
          <SVCurrencyInput
            name="checkDepositAccountLimitPerCalendarDay"
            label={MAX_DAILY_DEPOSIT_PER_BANK_ACCOUNT.LABEL}
          />
          <Typography variant="body2" color="text.secondary" mt={0}>
            (Calendar EST Aggregate)
          </Typography>
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 6 }}>
        <Stack spacing={1} sx={{ width: '100%' }}>
          <SVCurrencyInput
            name="checkDepositAccountLimitPerCalendarMonth"
            label={MAX_MONTHLY_DEPOSIT_PER_BANK_ACCOUNT.LABEL}
          />
          <Typography variant="body2" color="text.secondary" mt={0}>
            (Calendar Month)
          </Typography>
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 6 }}>
        <Stack spacing={1} sx={{ width: '100%' }}>
          <SVCurrencyInput
            name="checkDepositProgramLimitPerRollingDay"
            label={MAX_DAILY_DEPOSIT_PER_PROGRAM.LABEL}
          />
          <Typography variant="body2" color="text.secondary" mt={0}>
            (24 Hour Rolling Aggregate)
          </Typography>
        </Stack>
      </Grid>
    </Grid>
  );
};
